import { queryOptions, useQuery } from '@tanstack/react-query';

import { chatSettingsApi } from '../api/chat-settings-api';

import { chatSettingsKeys } from './chat-settings-keys';

export function shortcutsQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: chatSettingsKeys.shortcuts(storeId),
    queryFn: () => chatSettingsApi.shortcuts(storeId),
  });
}

/** Organisation, store and the caller's own shortcuts usable on this store. */
export function useShortcuts(storeId: string) {
  return useQuery(shortcutsQueryOptions(storeId));
}
